import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { financialData } from '../../data/financialData';

const CustomersChart = () => {
  return (
    <div className="bg-gray-900/90 backdrop-blur-md p-6 rounded-xl shadow-2xl border border-green-500/30 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-green-900/20 pointer-events-none" />
      <div className="relative z-10">
      <h3 className="text-xl font-bold text-white mb-6 text-center tracking-wide">Cumulative AI Customers (in Millions)</h3>
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={financialData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
          <XAxis dataKey="year" stroke="#9ca3af" />
          <YAxis tickFormatter={(value) => `${value}M`} stroke="#9ca3af" />
          <Tooltip
            formatter={(value) => `${value}M`}
            cursor={{ fill: 'rgba(0, 155, 58, 0.1)' }}
            contentStyle={{
              backgroundColor: 'rgba(31, 41, 55, 0.95)',
              border: '1px solid #10b981',
              borderRadius: '12px',
              color: '#ffffff'
            }}
            labelStyle={{ fontWeight: 'bold', color: '#ffffff' }}
          />
          <Legend />
          <Bar dataKey="cumulativeCustomers" name="Cumulative Customers" fill="#10b981" />
        </BarChart>
      </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CustomersChart;